// Central site URL configuration
// Change this single value when the domain changes
export const SITE_URL = 'https://www.i-rent.net';
